// extracted by mini-css-extract-plugin
export default {"wave":"style_wave__Vxotm","Image2":"style_Image2__3xMfF","mbb":"style_mbb__pQgH9","line2":"style_line2__TjK5H","mm":"style_mm__mllvu"};